<template>
    <v-btn
        v-if="dikidHrefInfo"
        class="svg-icon"
        icon
        @click="openInNewTab(getClientRefFromParsed(dikidHrefInfo))"
        :style="`width:${btnWidth}px;height:${btnHeight}px`"
    >
        <v-icon :size="size" color="mainNew">{{ '$vuetify.icons.dikidi' }}</v-icon></v-btn
    >
</template>
<script>
import { openInNewTab } from '@root/src/utils'
import { getClientRefFromParsed } from '../chisai/getClientsBack/helpers'
import { CONNECTOR_TYPES } from '@root/src/vars/general'
export default {
    name: 'dikidiLink',
    components: {},
    props: {
        hrefInfo: {
            type: Array,
            default: () => [],
        },
        size: {
            type: Number,
            default: 18,
        },
        btnWidth: {
            type: Number,
            default: 36,
        },
        btnHeight: {
            type: Number,
            default: 36,
        },
    },
    data: () => ({}),
    computed: {
        dikidHrefInfo() {
            return this?.hrefInfo?.find(el => el.connectorType === CONNECTOR_TYPES.dikidi)
        },
    },
    methods: { openInNewTab, getClientRefFromParsed },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
</style>
